<div class="toolbar" fxLayout="row" fxLayoutAlign="space-between">
  <div fxLayout="row" fxLayoutAlign="start center" style="width: 100%">
    <fury-toolbar-sidenav-mobile-toggle (openSidenav)="openSidenav.emit()"></fury-toolbar-sidenav-mobile-toggle>

    <div [fxShow.gt-sm]="topNavigation$ | async" [fxShow.xs]="false" [routerLink]="['/']" class="toolbar-logo" fxShow>
      <h1>DCBM</h1>
      <!-- <div class="logo fill-primary-contrast">
        <img src="./assets/img/logo-dark.png" />
      </div> -->
    </div>

    <app-search-bar style="width: 100%"></app-search-bar>
  </div>

  <div fxLayout="row">
    <!--   <fury-toolbar-fullscreen-toggle class="toolbar-button"></fury-toolbar-fullscreen-toggle>

    <fury-toolbar-search fxHide fxShow.gt-sm fxHide.gt-md class="toolbar-button"></fury-toolbar-search>

    <fury-toolbar-notifications class="toolbar-button"></fury-toolbar-notifications>

    <fury-toolbar-user [profile]="profile" class="toolbar-button"></fury-toolbar-user> -->

    <fury-toolbar-quickpanel-toggle
      *ngIf="isManager"
      [fxShow.gt-sm]="topNavigation$ | async"
      (openQuickPanel)="openQuickPanel.emit()"
      class="toolbar-button"
    ></fury-toolbar-quickpanel-toggle>
  </div>
</div>
